import { arrayOf, func } from 'prop-types';
import React from 'react';

import { clBusinessLineShape } from '../../prop-types';
import ConnectedBusinessLine from './BusinessLine.container';

function CampaignLineTable({ campaignLines, onChange, ...rest }) {
  return (
    <div className="mb-5">
      {campaignLines.map((line, idx) => (
        <ConnectedBusinessLine
          {...line}
          {...rest}
          name={`campaignLines[${idx}]`}
          onChange={onChange}
          key={line.label}
        />
      ))}
    </div>
  );
}

CampaignLineTable.propTypes = {
  campaignLines: arrayOf(clBusinessLineShape),
  onChange: func,
};

CampaignLineTable.defaultProps = {
  campaignLines: [],
  onChange: undefined,
};

export default CampaignLineTable;
